import axios from 'axios';

export default {
  getMessageTemplates(regionId) {
    return axios.get(
      `${process.env.VUE_APP_NEW_API_URL}/staff/regions/${regionId}/templates/message`,
    );
  },
};
